import { IConsumable } from "../../home/types/Menu";

/**
 * Выбранный расходник корзины. Храним не только id, но и русскую подпись:
 * заказ собирает чекаут, у него меню под рукой нет, а consumables читают на
 * кухне — там нужен русский, а не язык интерфейса.
 */
export type OrderExtra = {
  id: number;
  title: string;
};

const STORAGE_KEY = "orderExtras";

const isBrowser = typeof window !== "undefined";

const isOrderExtra = (value: unknown): value is OrderExtra =>
  !!value &&
  typeof value === "object" &&
  typeof (value as OrderExtra).id === "number" &&
  typeof (value as OrderExtra).title === "string";

// Подпись для кухни: русская, с откатом на любую другую — лишь бы строка в
// заказе не оказалась пустой.
export const getOrderExtraCommentTitle = (consumable: IConsumable) =>
  consumable.title_ru ||
  consumable.title ||
  consumable.title_uz ||
  consumable.title_en ||
  "";

export const toOrderExtra = (consumable: IConsumable): OrderExtra => ({
  id: consumable.id,
  title: getOrderExtraCommentTitle(consumable),
});

export const getStoredOrderExtras = (): OrderExtra[] => {
  if (!isBrowser) {
    return [];
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) {
      return [];
    }

    const parsed = JSON.parse(stored);

    if (!Array.isArray(parsed)) {
      return [];
    }

    // Отфильтровываем всё незнакомое: в localStorage может лежать выбор из
    // прошлой версии приложения — там это были строки вроде "napkins".
    return parsed.filter(isOrderExtra);
  } catch {
    return [];
  }
};

export const saveStoredOrderExtras = (extras: OrderExtra[]) => {
  if (!isBrowser) {
    return;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(extras));
};

export const clearStoredOrderExtras = () => {
  if (!isBrowser) {
    return;
  }

  localStorage.removeItem(STORAGE_KEY);
};

